import { posthog } from "posthog-js";

function isLocalPostHogEnvironment() {
  return import.meta.env.DEV || window.PARROT_CONFIG?.PARROT_ENV === "local";
}

export function shouldCapturePostHogExceptions() {
  return !isLocalPostHogEnvironment();
}

export function capturePostHogException(
  error: unknown,
  properties?: Record<string, unknown>
) {
  if (!shouldCapturePostHogExceptions()) return;

  posthog.captureException(error, {
    app_release: import.meta.env.VITE_POSTHOG_RELEASE_VERSION,
    parrot_env: window.PARROT_CONFIG?.PARROT_ENV,
    ...properties,
  });
}
